module.exports = __webpack_public_path__ + "media/images/check-42b5661b09d7c3246ab5a36b15ac2e34.svg";